<ng-container *transloco="let t; prefix: 'property-upload-wizard'">
  <div class="container flex flex-1 flex-col rfs:gap-28 items-center mb-4">
    <progress-stepper class="progress-stepper-onboarding" [StepNo]="5" [Steps]="Steps"></progress-stepper>
    <div class="md:container w-full flex flex-1 flex-col rfs:gap-28 items-center justify-between">
      <div class="w-full flex flex-col gap-12 items-center justify-center">
        <div class="w-full overflow-x-hidden" [innerHTML]="this.htmlStr"></div>

        <div class="w-full p-4 border-gray-400 border rounded mb-12">
          <label for="checkbox-selector-terms" class="checkbox-selector w-full">
            <input type="checkbox" class="hidden" [checked]="this.termsAccepted" id="checkbox-selector-terms"
              name="checkbox-selector-term" (change)="onConsent($event)" />
            <div class="checkbox-selector-content">
              <span class="checkbox-selector-text text-black ml-4 font-normal">
                {{t('labels.brokerageAgreementTermsCheckbox')}}
              </span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
  <app-property-upload-navigation [loading]="loading" [HidePrevious]="false" [NextDisabled]="!data.isValid"
    (NextButtonClicked)="saveStep()"
    (PreviousButtonClicked)="previousButtonClicked.emit()"></app-property-upload-navigation>
</ng-container>